<template>
    <div :class="[{'app-en':lang === 'en'}, 'app-canvas-wrap']">
        <Nav ref="navchild"></Nav>
        <Loader :speed="loadprogress" v-if="!hadLoaded" />
        <div ref="webgl" id="webgl"></div>
        <!-- logo -->
        <div class="logo">
            <a href="/"><img src="../assets/logo.png" /></a>
        </div>
        <!-- CN|EN -->
        <language @custom-event="handleChildEvent" />
        <!-- 注意事项文字 -->
        <transition>
          <div class="app-text" v-if="attentionStatus&&attentionText">
            <div class="title" @click="shownote()">
                <img src="../assets/images/text.png" />
                <span  v-show="lang == 'cn'">注意</span>
                <span  v-show="lang == 'en'">NOTE</span>
            </div>
            <div class="content" v-html="attentionText" v-show="is_hidenote"></div>
          </div>
        </transition>
        <!-- 菜单栏 -->
        <div class="app-toolbar">
            <div class="app-toolbar-circle">
                <div class="ring"></div>
                <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" height="100%">
                    <g class="ring">
                        <g class="toolbar-item" @click="openLink()">
                            <path
                                d="M 482.13602837739217 125.84452286971282 L 452.40303192456616 51.57508822842692 A 720 720 0 0 1 583.7391040605069 13.011337970850718 L 598.8792036093395 91.56563375186738 A 640 640  0 0 0 482.13602837739217 125.84452286971282 z"
                                fill="transparent" stroke="transparent" stroke-width="0">
                            </path>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="45" v-if="lang == 'cn'">
                                <textPath xlink:href="#SvgjsPath1031">官 网</textPath>
                            </text>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="36" v-if="lang == 'en'">
                                <textPath xlink:href="#SvgjsPath1031">Website</textPath>
                            </text>
                        </g>
                        <g :class="[{'active':toobarActive == 'disassemble'}, 'toolbar-item']" @click="selectToobar('disassemble')">
                            <path
                                d="M 598.8792036093395 91.56563375186738 L 583.7391040605069 13.011337970850718 A 720 720 0 0 1 720.0000000000024 0 L 720.0000000000022 80 A 640 640  0 0 0 598.8792036093395 91.56563375186738 z"
                                fill="transparent" stroke="transparent" stroke-width="0">
                            </path>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="45" v-if="lang == 'cn'">
                                <textPath xlink:href="#SvgjsPath1032">拆 卸</textPath>
                            </text>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="10" v-if="lang == 'en'">
                                <textPath xlink:href="#SvgjsPath1032">Disassemble</textPath>
                            </text>
                        </g>
                        <g :class="[{'active':toobarActive == 'assemble'}, 'toolbar-item']" @click="selectToobar('assemble')">
                            <path
                                d="M 720 80 L 720 0 A 720 720 0 0 1 856.2608959394953 13.011337970851173 L 841.1207963906625 91.56563375186772 A 640 640  0 0 0 720 80 z"
                                fill="transparent" stroke="transparent" stroke-width="0">
                            </path>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="45" @mouseenter="greet" v-if="lang == 'cn'">
                                <textPath xlink:href="#SvgjsPath1000">装 配</textPath>
                            </text>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="31" @mouseenter="greet" v-if="lang == 'en'">
                                <textPath xlink:href="#SvgjsPath1000">Assemble</textPath>
                            </text>
                        </g>
                        <!-- <g :class="[{'active':toobarActive == 'outer'}, 'toolbar-item']" @click="selectToobar('outer')">
                            <path
                                d="M 841.1207963906625 91.56563375186772 L 856.2608959394953 13.011337970851173 A 720 720 0 0 1 987.5969680754358 51.57508822842772 L 957.8639716226096 125.8445228697135 A 640 640  0 0 0 841.1207963906625 91.56563375186772 z"
                                fill="transparent" stroke="transparent" stroke-width="0">
                            </path>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="45" v-if="lang == 'cn'">
                                <textPath xlink:href="#SvgjsPath1001">型号</textPath>
                            </text>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="46" v-if="lang == 'en'">
                                <textPath xlink:href="#SvgjsPath1001">Type</textPath>
                            </text>
                        </g> -->
                    </g>
                    <defs>
                        <path id="SvgjsPath1000"
                            d="M 720 49 L 720 48 A 672 672 0 0 1 847.1768362101957 60.143915439461125 L 846.9875849658353 61.1258441367238 A 671 671  0 0 0 720 49 z">
                        </path>
                        <path id="SvgjsPath1001"
                            d="M 846.9875849658353 61.1258441367238 L 847.1768362101957 60.143915439461125 A 672 672 0 0 1 969.7571702037401 96.13674901319928 L 969.3855077480798 97.06511694621531 A 671 671  0 0 0 846.9875849658353 61.1258441367238 z">
                        </path>
                        <path id="SvgjsPath1031"
                            d="M 470.6144922519221 97.06511694621452 L 470.2428297962618 96.13674901319848 A 672 672 0 0 1 592.8231637898064 60.14391543946067 L 593.0124150341668 61.12584413672346 A 671 671  0 0 0 470.6144922519221 97.06511694621452 z">
                        </path>
                        <path id="SvgjsPath1032"
                            d="M 593.0124150341668 61.12584413672346 L 592.8231637898064 60.14391543946067 A 672 672 0 0 1 720.0000000000023 48 L 720.0000000000023 49 A 671 671  0 0 0 593.0124150341668 61.12584413672346 z">
                        </path>
                    </defs>
                </svg>
            </div>
            <div class="app-submenu-wrap" v-if="toobarActive === 'disassemble'">
                    <div
                      v-for="(item,index) in disassembleObj"
                      :key="index"
                      :class="[{'active':disassembleActive === item.id}, 'app-submenu-item']"
                      @click="disassembleAnimate(item)"
                    >
                        <template v-if="lang == 'cn'">
                            {{ item.text }}
                        </template>
                        <template v-if="lang == 'en'">
                            {{ item.en_text }}
                        </template>
                    </div>
            </div>
            <div class="app-submenu-wrap" v-if="toobarActive === 'assemble'">
                    <div
                      v-for="(item,index) in assembleObj"
                      :key="index"
                      :class="[{'active':assembleActive === item.id}, 'app-submenu-item']"
                      @click="assembleAnimate(item)"
                    >
                        <template v-if="lang == 'cn'">
                            {{ item.text }}
                        </template>
                        <template v-if="lang == 'en'">
                            {{ item.en_text }}
                        </template>
                    </div>
            </div>
        </div>

        <!-- <div @click="test" class="test">测试</div> -->

    </div>
</template>

<script>
    import * as THREE from  'three';
    import TWEEN from '@tweenjs/tween.js';
    import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
    import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
    import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js';
    import { MeshoptDecoder } from 'three/examples/jsm/libs/meshopt_decoder.module.js'

    // import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
    // import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
    // import { OutlinePass  } from 'three/examples/jsm/postprocessing/OutlinePass.js';
    // // ShaderPass功能：使用后处理Shader创建后处理通道
    // import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js';
    // // FXAA抗锯齿Shader
    // import { FXAAShader } from 'three/examples/jsm/shaders/FXAAShader.js';
    // // SMAA抗锯齿通道
    // import { SMAAPass } from 'three/examples/jsm/postprocessing/SMAAPass.js';
    // // 伽玛校正后处理Shader
    // import { GammaCorrectionShader } from 'three/examples/jsm/shaders/GammaCorrectionShader';
    // import { CSS2DRenderer,CSS2DObject } from 'three/examples/jsm/renderers/CSS2DRenderer.js';
    // // 引入CSS3渲染器CSS3DRenderer
    // // import { CSS3DRenderer,CSS3DObject } from 'three/examples/jsm/renderers/CSS3DRenderer.js';

    import Loader from './Loader.vue';
    import Nav from './nav.vue';
    import language from './language.vue';

    var scene;

    export default {

        components: {
            Loader,
            Nav,
            language,
        },

        data() {
            return {
                timer: null, // 定时器
                hadLoaded: false, // 是否已加载完毕
                loadprogress: 0, // 加载进度
                modelLoaded: false, // 模型是否加载

                lang: 'cn', // 语言
                Clock: null, // 用于跟踪时间
                camera: null, // 相机对象
                renderer: null, // 渲染器对象
                container: null, // DOM节点
                controls: null, // 轨道控制器
                containerW: 0, // DOM宽度
                containerH: 0, // DOM高度
                model: null, //模型
                toobarActive: null, // 工具栏状态
                attentionStatus: false, // 注意事项状态
                attentionText: null, // 注意事项文字
                is_hidenote:true,

                selectobject: '', //当前选择的选项
                disassembleActive:null,
                assembleActive:null,

                allcomponent:['1ls','2ls','1b','2b','1sgd','2sgd','1dwx','2dwx','3dwx','4dwx','5dwx','6dwx','7dwx','8dwx','yidonglist','jiantou1','jiantou2','jiantou3','banshou'], //所有隐藏组件名称列表
                animationtimeoutlist:[], //计时器列表
                disassembleObj:[ //拆卸对象选项
                  //------------------------------------------------------
                  {
                    id: 0,
                    text: '步骤一', //菜单显示
                    en_text: 'Step 1', //菜单显示(英文)
                    // showtext: '手动推式', //页面显示的名称
                    // en_showtext: 'push only adjustment', //页面显示的名称(英文)
                    // modelname:"shoudongtuishi", //模型零件名称
                    // coordinate_list:[-4.8, 1.3, -0.6], //标注坐标
                    animationstart:0, //动画开始时间(s)
                    animationend:10500, //动画播放时间(ms)
                    animationnumber:0, //动画序列号
                    animationnum:1, //动画片段号
                    hideComponent:['1sgd','7yidong','8yidong','2sgd','1dwx','2dwx','16yidong','17yidong','3dwx','4dwx','5dwx','6dwx','7dwx','8dwx','jiantou1','jiantou2','jiantou3','banshou'], //需要隐藏的组件名称列表
                    warn: '<p>1.安装侧板吊装块，安装固定螺丝；</p><p>2.整体模头下降放置到拆模小车上；</p><p>3.闭合主支撑座盖（锁紧螺丝）；</p><p>4.将定位销嵌入分度盘。</p>',
                    en_warn: '<p>1.Install the side plate lifting block and  fixing screws</p><p>2.Lower die body and place it on maintenance cart</p><p>3.Close the main support cover (locking screw)</p><p>4.Embed the positioning pin into index plate</p>',
                    cameracoordinate:{ //相机坐标
                      x:77,
                      y:52,
                      z:-126
                    },
                  },
                  //------------------------------------------------------
                  {
                    id: 1,
                    text: '步骤二', //菜单显示
                    en_text: 'Step 2', //菜单显示(英文)
                    animationstart:11, //动画开始时间(s)
                    animationend:6000, //动画播放时间(ms)
                    animationnumber:0, //动画序列号
                    animationnum:2, //动画片段号
                    hideComponent:['3dwx','4dwx','5dwx','6dwx','7dwx','8dwx','banshou','jiantou1','jiantou3'], //需要隐藏的组件名称列表
                    warn: '<p>1.拆卸主模体合模螺丝；</p><p>2.拆除拆模小车连接螺杆；</p><p>3.分离拆模小车。</p>',
                    en_warn: '<p>1.Remove die clamping screws of the main die body</p><p>2.Remove the connecting screw of maintenance cart</p><p>3.Separate maintenance cart</p>',
                    cameracoordinate:{ //相机坐标
                      x:72,
                      y:61,
                      z:-124
                    },
                  },
                  //------------------------------------------------------
                  {
                    id: 2,
                    animationnumber:0, //动画序列号
                    text: '步骤三', //菜单显示
                    en_text: 'Step 3', //菜单显示(英文)
                    animationstart:17, //动画开始时间
                    animationend:15000, //动画播放时间
                    animationnum:3, //动画片段号
                    hideComponent:['1b','2b','3dwx','4dwx','5dwx','6dwx','7dwx','8dwx','banshou','yidonglist','1ls','jiantou1','jiantou2','jiantou3'], //需要隐藏的组件名称列表
                    warn: '<p>1.拔除主模体定位销；</p><p>2.闭合升降机支撑座盖（锁紧螺丝）；</p><p>3.正向旋转手轮A/提升模体；</p><p>4.正向旋转手轮B/移动副支架；</p><p>5.反向旋转手轮A/将前模放置于副支架上，固定副支撑座盖。</p>',
                    en_warn: '<p>1.Remove the positioning pin of the die body;</p><p>2.Close the lift support cover (locking screw)</p><p>3.Rotate hand wheel A forward/lift the die;</p><p>4.Rotate handwheel B forward/move the sub-bracket;</p><p>5.Rotate handwheel A in the opposite direction/place the front die on the sub-bracket and fix the auxiliary support seat cover.</p>',
                    cameracoordinate:{ //相机坐标
                      x:92,
                      y:42,
                      z:76
                    },
                  },
                  //------------------------------------------------------
                  {
                    id: 3,
                    animationnumber:0, //动画序列号
                    text: '步骤四', //菜单显示
                    en_text: 'Step 4', //菜单显示(英文)
                    animationstart:32, //动画开始时间
                    animationend:10500, //动画播放时间
                    animationnum:4, //动画片段号
                    hideComponent:['1b','2b','1dwx','2dwx','3dwx','4dwx','2ls','banshou','yidonglist','1ls','jiantou1','jiantou2','jiantou3'], //需要隐藏的组件名称列表
                    warn: '<p>1.打开升降机支撑座盖；</p><p>2.反向旋转手轮A/将升降机缩回原位；</p><p>3.安装主模体和前模体的分度盘定位销；</p><p>4.拆卸前模体合模螺丝；</p><p>5.反向旋转手轮B,分离主/前模体。</p>',
                    en_warn: '<p>1.Open the lift support seat cover</p><p>2.Rotate handwheel A in the opposite direction/retract the worm gear lift to its original position </p><p>3.Install index plate positioning pins of the main die body and the front die body</p><p>4.Remove the die clamping screws of the front die body;</p><p>5.Reversely rotate handwheel B to separate the main/front die body</p>',
                    cameracoordinate:{ //相机坐标
                      x:73,
                      y:43,
                      z:93
                    },
                  },
                  //------------------------------------------------------
                  {
                    id: 4,
                    animationnumber:0, //动画序列号
                    text: '步骤五', //菜单显示
                    en_text: 'Step 5', //菜单显示(英文)
                    animationstart:42.5, //动画开始时间
                    animationend:11000, //动画播放时间
                    animationnum:5, //动画片段号
                    hideComponent:['1b','2b','2ls','yidonglist','1ls','jiantou1','jiantou2','jiantou3'], //需要隐藏的组件名称列表
                    warn: '<p>1.将六角扳手套在分度盘上；</p><p>2.拆卸主模体分度盘的定位销；</p><p>3.旋转扳手/翻转主模体；</p><p>4.将定位销插入主模体分度盘；</p><p>5.取下六角扳手。</p>',
                    en_warn: '<p>1.Put hex wrench on index plate</p><p>2.Remove the positioning pin of index plate of the main die body </p><p>3.Rotate the wrench/turn over the main die body</p><p>4.Insert the positioning pin into the index plate of the main die body</p><p>5.Remove hex wrench.</p>',
                    cameracoordinate:{ //相机坐标
                      x:31,
                      y:47,
                      z:127
                    },
                  },
                ],
                assembleObj: [ //装配对象选项
                  //------------------------------------------------------
                  {
                    id: 0,
                    animationnumber:1, //动画序列号
                    text: '步骤一', //菜单显示
                    en_text: 'Step 1', //菜单显示(英文)
                    animationstart:0, //动画开始时间
                    animationend:11000, //动画播放时间
                    animationnum:1, //动画片段号
                    hideComponent:['1ls','2ls','1b','2b','yidonglist','jiantou1','jiantou2','jiantou3'], //需要隐藏的组件名称列表
                    warn: '<p>1.将六角扳手套在分度盘上；</p><p>2.拔除前模体定位销；</p><p>3.旋转扳手/翻转前模体；</p><p>4.将定位销插入前模体分度盘</p><p>5.取下六角扳手</p>',
                    en_warn: '<p>1.Put hex wrench on the index plate;</p><p>2.Remove the positioning pin of the front die body;</p><p>3.Rotate the wrench/turn over the front die body;</p><p>4.Insert the positioning pin into the index plate of the front die body</p><p>5.Remove hex wrench</p>',
                    cameracoordinate:{ //相机坐标
                      x:114,
                      y:40,
                      z:68
                    },
                  },
                  //------------------------------------------------------
                  {
                    id: 1,
                    animationnumber:1, //动画序列号
                    text: '步骤二', //菜单显示
                    en_text: 'Step 2', //菜单显示(英文)
                    animationstart:11, //动画开始时间
                    animationend:10000, //动画播放时间
                    animationnum:2, //动画片段号
                    hideComponent:['1ls','1b','2b','yidonglist','banshou','jiantou1','jiantou2'], //需要隐藏的组件名称列表
                    warn: '<p>1.旋转手轮B,合并主/前模体；</p><p>2.安装前模体合模螺丝；</p><p>3.拆卸前模体的分度盘定位销；</p><p>4.打开升降机支撑座盖；</p><p>5.旋转手轮A/将前模体固定在升降机U型座上；</p><p>6.闭合升降机支撑座盖。</p>',
                    en_warn: '<p>1.Rotate handwheel B to merge the main/front die body;</p><p>2.Install the front die body clamping screws;</p><p>3.Remove the index plate positioning pin of the front die body;</p><p>4.Open the lift support seat cover;</p><p>5.Rotate handwheel A/fix the front die body on the U-shaped base of the lift;</p><p>6.Close the lift support cover</p>',
                    cameracoordinate:{ //相机坐标
                      x:104,
                      y:44,
                      z:78
                    },
                  },
                  //------------------------------------------------------
                  {
                    id: 2,
                    animationnumber:1, //动画序列号
                    text: '步骤三', //菜单显示
                    en_text: 'Step 3', //菜单显示(英文)
                    animationstart:21, //动画开始时间
                    animationend:12000, //动画播放时间
                    animationnum:3, //动画片段号
                    hideComponent:['1ls','1b','2b','3dwx','yidonglist','banshou','jiantou1','jiantou2','jiantou3'], //需要隐藏的组件名称列表
                    warn: '<p>1.拔除主模体定位销；</p><p>2.打开副支撑座盖；</p><p>3.正向旋转手轮A/将前模体提升，与副支架分离；</p><p>4.反向旋转手轮B/向外移动副支架；</p><p>5.反向旋转手轮A/将模体旋转至竖直状态。</p>',
                    en_warn: '<p>1.Remove the positioning pin of the main die;</p><p>2.Open the auxiliary support seat cover;</p><p>3.Rotate handwheel A in the forward direction/lift the front die body and separate it from the sub-bracket;</p><p>4.Rotate handwheel B in the opposite direction/move the sub-bracket outward;</p><p>5.Reversely rotate handwheel A/rotate the die to a vertical state</p>',
                    cameracoordinate:{ //相机坐标
                      x:93,
                      y:56,
                      z:83
                    },
                  },
                  //------------------------------------------------------
                  {
                    id: 3,
                    animationnumber:1, //动画序列号
                    text: '步骤四', //菜单显示
                    en_text: 'Step 4', //菜单显示(英文)
                    animationstart:33, //动画开始时间
                    animationend:8000, //动画播放时间
                    animationnum:4, //动画片段号
                    hideComponent:['1ls','3dwx','4dwx','5dwx','6dwx','yidonglist','banshou','jiantou1','jiantou3'], //需要隐藏的组件名称列表
                    warn: '<p>1.将拆模小车框架靠近；</p><p>2.安装拆模小车连接螺杆；</p><p>3.旋转连接螺杆，牵引两拆模小车框架闭合。</p>',
                    en_warn: '<p>1.Move maintenance cart closer;</p><p>2.Install the connecting screw of maintenance cart ;</p><p>3.Rotate the connecting screw and pull the two maintenance cart frames to close.</p>',
                    cameracoordinate:{ //相机坐标
                      x:74,
                      y:90,
                      z:-109
                    },
                  },
                  //------------------------------------------------------
                  {
                    id: 4,
                    animationnumber:1, //动画序列号
                    text: '步骤五', //菜单显示
                    en_text: 'Step 5', //菜单显示(英文)
                    animationstart:41, //动画开始时间
                    animationend:11000, //动画播放时间
                    animationnum:5, //动画片段号
                    hideComponent:['3dwx','4dwx','5dwx','6dwx','banshou','jiantou1','jiantou2','jiantou3'], //需要隐藏的组件名称列表
                    warn: '<p>1.拔出主模体定位销；</p><p>2.打开U型座盖/主支撑座盖（拆除螺丝）；</p><p>3.提升模体，与拆模小车分离；</p><p>4.拆卸侧板固定螺丝，分离侧板吊装块。</p>',
                    en_warn: '<p>1.Pull out the positioning pin of the main die;</p><p>2.Open the U-shaped seat cover/main support seat cover (remove the screws);</p><p>3.Lift the die body and separate it from maintenance cart;</p><p>4.Remove the side plate fixing screws and separate the side plate lifting blocks.</p>',
                    cameracoordinate:{ //相机坐标
                      x:58,
                      y:77,
                      z:-87
                    },
                  },
                ],
            }
        },

        mounted: function () {
            let _this = this;

            _this.initCanvas();

            _this.timer = setInterval(function() {
                if ( !_this.hadLoaded ) {
                    if ( _this.loadprogress < 80 ) {
                        _this.loadprogress += 0.8;
                    } else if ( _this.modelLoaded ) {
                        if ( _this.loadprogress <= 100 ) {
                            _this.loadprogress += 2;
                        } else {
                            _this.hadLoaded = true;
                            clearInterval(_this.timer);
                            _this.timer = null;
                        }
                    }
                }
            }, 20);
            // this.raycasterclick()
            window.addEventListener("resize", _this.onResize, false);
            if(sessionStorage.getItem('language')){
              this.lang = sessionStorage.getItem('language');
            }else{
              sessionStorage.setItem('language',this.lang); // 存入一个值
            }
        },
        beforeDestroy(){
          let _this = this
          _this.scene.remove(_this.model)
          _this.model.traverse(function (object) {
            if (object.type === 'Mesh') {
              object.geometry.dispose()
              object.material.dispose()
            }
          })
        },
        methods: {
          greet () {
            return
          },
          handleChildEvent(){
            this.lang = sessionStorage.getItem('language')
            this.$refs.navchild.childchangelang();
            if (this.lang == 'cn') {
              if(this.selectobject.warn){
                this.attentionText = this.selectobject.warn;
              }else{
                this.attentionText = null
              }
            } else {
              if(this.selectobject.en_warn){
                this.attentionText = this.selectobject.en_warn;
              }else{
                this.attentionText = null
              }
            }

          },
          /**
           * @description 打开链接
           * @param {*} link
           */
          openLink: function(link) {
            if (this.lang == 'cn') {
              window.open('https://www.jc-times.com/', '_blank');
            } else {
              window.open('https://en.jc-times.com/', '_blank');
            }
          },
          /**
           * @description 相机动画
           */
          tweenCamera: function(oldP, oldT, newP, newT, callBack) {
            var _this = this
            var tween = new TWEEN.Tween({
              x1: oldP.x, // 相机x
              y1: oldP.y, // 相机y
              z1: oldP.z, // 相机z
              x2: oldT.x, // 控制点的中心点x
              y2: oldT.y, // 控制点的中心点y
              z2: oldT.z  // 控制点的中心点z
            });
            tween.to({
              x1: newP.x,
              y1: newP.y,
              z1: newP.z,
              x2: newT.x,
              y2: newT.y,
              z2: newT.z
            }, 1000);
            tween.onUpdate(function (object) {
              _this.camera.position.x = object.x1;
              _this.camera.position.y = object.y1;
              _this.camera.position.z = object.z1;
              _this.controls.target.x = object.x2;
              _this.controls.target.y = object.y2;
              _this.controls.target.z = object.z2;
              _this.controls.update();
            })
            tween.onComplete(function () {
              _this.controls.enabled = true;
              callBack && callBack()
            })
            tween.easing(TWEEN.Easing.Cubic.InOut);
            tween.start();
          },

          /**
           * @description 初始化Canvas
           */
          initCanvas: function() {
              let _this = this;

              _this.clock = new THREE.Clock();

              // 创建渲染器
              _this.initRenderer();

              // 创建场景
              _this.initScene();

              // 创建相机
              _this.initCamera();

              // 创建相机控制器
              _this.initControls();

              // 创建环境贴图
              _this.initPmremGenerator();

              // 创建环境光
              _this.initAmbientLight()

              // 加载模型
              _this.loadModel();

          },

          /**
           * @description 初始化渲染器
           */
          initRenderer: function() {
              let _this = this;
              _this.container = this.$refs.webgl;
              _this.containerW = this.$refs.webgl.getBoundingClientRect().width;
              _this.containerH = this.$refs.webgl.getBoundingClientRect().height;
              // _this.containerW = window.innerWidth
              // _this.containerH = window.innerHeight
              _this.renderer = new THREE.WebGLRenderer({
                  antialias: true,
                  alpha: true
              });
              _this.renderer.setSize(this.containerW,this.containerH);
              _this.renderer.localClippingEnabled = true;
              _this.renderer.clippingPlanes = Object.freeze([])
              _this.renderer.setClearAlpha(0);
              _this.renderer.setPixelRatio(window.devicePixelRatio);
              _this.renderer.outputEncoding = THREE.sRGBEncoding;
              _this.container.appendChild(_this.renderer.domElement);
          },

          /**
           * @description 初始化场景
           */
          initScene: function() {
              let _this = this;
              _this.scene = new THREE.Scene();
          },

          /**
           * @description 初始化相机
           */
          initCamera: function() {
            let _this = this;
            _this.camera = new THREE.PerspectiveCamera(45, this.containerW / this.containerH, 0.1, 10000);
            _this.camera.position.set(92, 42, -121);
            _this.camera.lookAt(_this.scene.position);
          },

          /**
           * @description 初始化相机控制器
           */
          initControls: function() {
              let _this = this;
              _this.controls = new OrbitControls(_this.camera, _this.renderer.domElement);
              _this.controls.enablePan = false;
              _this.controls.enableDamping = true;
              _this.controls.dampingFactor = 0.1;
              _this.controls.maxPolarAngle = Math.PI;
              _this.controls.minPolarAngle = 0;
              _this.controls.enablePan = false;
              _this.controls.enableZoom = true;
          },
          /**
           * @description 初始化添加环境光
           */
          initAmbientLight: function() {
            let _this = this;
            const light = new THREE.AmbientLight( 0xeeeeee , 0.2 ); // 柔和的白光
            _this.scene.add( light );
          },
          /**
           * @description 初始化环境贴图
           */
          initPmremGenerator: function() {
            let _this = this;
            let pmremGenerator = new THREE.PMREMGenerator(_this.renderer);
            let loaderRGBE = new RGBELoader();
            pmremGenerator.compileEquirectangularShader()
            loaderRGBE.load('../../static/hdr/photo_studio_01_1k.hdr', texture => {
              const envMap = pmremGenerator.fromEquirectangular(texture).texture;
              _this.scene.environment = envMap;
              texture.dispose();
              pmremGenerator.dispose();
            })
          },

          /**
           * @description 加载模型文件
           */
          loadModel: function() {
              let _this = this;
              _this.textrueLoader = new THREE.TextureLoader();
              let loader = new GLTFLoader();
              loader.setMeshoptDecoder(MeshoptDecoder);
              loader.load("../../static/model/cmxc/cmxc.glb", function(gltf) {
                console.log(gltf,'gltf');
                _this.init_model = gltf
                _this.model = gltf.scene;
                _this.stopclip(11)
                // _this.model.scale.set(0.1, 0.1, 0.1);
                _this.hideMorphingAnimation("banshou")
                _this.hideMorphingAnimation("jiantou1")
                _this.hideMorphingAnimation("jiantou2")
                _this.hideMorphingAnimation("jiantou3")

                _this.hideMorphingAnimation("3dwx")
                _this.hideMorphingAnimation("4dwx")
                _this.hideMorphingAnimation("5dwx")
                _this.hideMorphingAnimation("6dwx")
                _this.hideMorphingAnimation("7dwx")
                _this.hideMorphingAnimation("8dwx")

                _this.modelLoaded = true;
                // _this.model.position.set(0, 100, 0);
                _this.scene.add(_this.model);
                _this.optimization_model_meaterial_performance()
                _this.animate();
              });
          },

          /**
           * @description 循环渲染Canvas
           */
          animate: function() {
            let _this = this;
            _this.rafId = requestAnimationFrame(_this.animate);
            _this.controls.update();
            TWEEN.update();
            // let mixerUpdateDelta = _this.clock.getDelta();
            // _this.mixer.update( mixerUpdateDelta );
            // _this.composer.render(); // 使用处理对象渲染场景
            _this.renderer.render(_this.scene, _this.camera);
            // _this.labelRenderer.render(_this.scene, _this.camera); //渲染html标签
          },

          /**
           * @description 改变窗口大小，重新渲染Canvas
           */
          onResize: function() {
              let _this = this;
              _this.$nextTick(()=>{
                if(_this.$refs.webgl.getBoundingClientRect()){
                  _this.containerW = _this.$refs.webgl.getBoundingClientRect().width
                  _this.containerH = _this.$refs.webgl.getBoundingClientRect().height
                  _this.camera.aspect = _this.containerW / _this.containerH;
                  _this.camera.updateProjectionMatrix();
                  _this.renderer.setSize(_this.containerW, _this.containerH);
                }
              })
          },

          /**
           * @description 选择语言
           */
          selectLang: function(e) {
              let _this = this;
              _this.lang = e;
              _this.toobarActive = '';
              _this.dismantleActive = '';
              _this.assembleActive = '';
          },

          /**
           * @description 选择菜单
           * @param {String} e 菜单
           */
          selectToobar: function(e) {
            if ( this.toobarActive == e ) {
              this.toobarActive = '';
              this.attentionStatus = false
            }else{
              if(e == 'disassemble' && this.disassembleActive != null){
                this.attentionStatus = true
              }else if(e == 'assemble' && this.assembleActive != null){
                this.attentionStatus = true
              }
              this.toobarActive = e;
            }
          },
          optimization_model_meaterial_performance(){
            let _this = this;
            _this.model.traverse(function (object) {
              if (object.isMesh && object.material.isMeshPhysicalMaterial) {
                // console.log(object,'isMeshPhysicalMaterial');
                let now_material = object.material
                // 创建一个新的 MeshStandardMaterial，可以根据需要调整属性
                let materialStandard = new THREE.MeshStandardMaterial({
                  color: now_material.color,
                  roughness: now_material.roughness, // 粗糙度
                  metalness: now_material.metalness, // 金属度
                  normalMap: now_material.normalMap, // 法线贴图
                  roughnessMap: now_material.roughnessMap, // 粗糙贴图
                  normalScale: now_material.normalScale, // 法线贴图强度
                  // 其他属性根据需要进行调整或者添加
                });
                // 将模型的材质替换为新的 MeshStandardMaterial
                object.material = materialStandard;
              }
            })
          },
          /**
           * @description 拆卸动画选项
           * @param {number} e 零件型号
           * @param {isload} e 是否为手动点击
           */
          disassembleAnimate: function(item,isload=true) {
            let _this = this
            this.disassembleActive = item.id
            this.assembleActive = null

            this.selectobject = item
            _this.attentionStatus = true;
            if (_this.lang == 'cn') {
              if(item.warn){
                _this.attentionText = item.warn;
              }else{
                _this.attentionText = null
              }
            } else {
              if(item.en_warn){
                _this.attentionText = item.en_warn;
              }else{
                _this.attentionText = null
              }
            }
            this.callAnimation(item)
            if(item.cameracoordinate){
              var oldP = { //旧的相机位置
                x: _this.camera.position.x,
                y: _this.camera.position.y,
                z: _this.camera.position.z,
              }
              var oldT = { //旧的聚焦位置
                x: _this.controls.target.x,
                y: _this.controls.target.y,
                z: _this.controls.target.z,
              }
              var newT = { //新的聚焦位置
                x: 0,
                y: 0,
                z: 0,
              }
              var newP = { //新的相机位置
                x: item.cameracoordinate.x,
                y: item.cameracoordinate.y,
                z: item.cameracoordinate.z,
              }
              _this.tweenCamera(oldP, oldT, newP, newT);
            }
          },

          /**
           * @description 装配动画选项
           * @param {Number} e 下模型号
           * @param {isload} e 是否为手动点击
           */
          assembleAnimate: function(item,isload=true) {
            let _this = this
            this.assembleActive = item.id
            this.disassembleActive = null
            _this.attentionStatus = true;
            this.selectobject = item
            if (_this.lang == 'cn') {
              if(item.warn){
                _this.attentionText = item.warn;
              }else{
                _this.attentionText = null
              }
            } else {
              if(item.en_warn){
                _this.attentionText = item.en_warn;
              }else{
                _this.attentionText = null
              }
            }
            this.callAnimation(item)

            if(item.cameracoordinate){
              var oldP = { //旧的相机位置
                x: _this.camera.position.x,
                y: _this.camera.position.y,
                z: _this.camera.position.z,
              }
              var oldT = { //旧的聚焦位置
                x: _this.controls.target.x,
                y: _this.controls.target.y,
                z: _this.controls.target.z,
              }
              var newT = { //新的聚焦位置
                x: 0,
                y: 0,
                z: 0,
              }
              var newP = { //新的相机位置
                x: item.cameracoordinate.x,
                y: item.cameracoordinate.y,
                z: item.cameracoordinate.z,
              }
              _this.tweenCamera(oldP, oldT, newP, newT);
            }
          },
          //显示隐藏注意提示
          shownote(){
            this.is_hidenote = !this.is_hidenote
          },
          /**
           * @description 射线拾取模型
           */
          raycasterclick(){
            let _this = this
            _this.renderer.domElement.addEventListener('click', function (event) {
              // .offsetY、.offsetX以canvas画布左上角为坐标原点,单位px
              const px = event.offsetX;
              const py = event.offsetY;
              //屏幕坐标px、py转WebGL标准设备坐标x、y
              //width、height表示canvas画布宽高度
              const x = (px / event.srcElement.clientWidth) * 2 - 1;
              const y = -(py / event.srcElement.clientHeight) * 2 + 1;
              //创建一个射线投射器`Raycaster`
              const raycaster = new THREE.Raycaster();
              //.setFromCamera()计算射线投射器`Raycaster`的射线属性.ray
              // 形象点说就是在点击位置创建一条射线，射线穿过的模型代表选中
              raycaster.setFromCamera(new THREE.Vector2(x, y), _this.camera);
              //.intersectObjects([mesh1, mesh2, mesh3])对参数中的网格模型对象进行射线交叉计算
              // 未选中对象返回空数组[],选中一个对象，数组1个元素，选中两个对象，数组两个元素
              const intersects = raycaster.intersectObjects([_this.model]);
              // console.log("射线器返回对象", intersects);
              // intersects.length大于0说明，说明选中了模型
              if (intersects.length > 0) {
                // 声明一个三维向量用来表示某个坐标
                // const worldPosition = new THREE.Vector3();
                // 获取mesh的世界坐标，你会发现mesh的世界坐标受到父对象group的.position影响
                // intersects[0].object.getWorldPosition(worldPosition);
                // console.log('世界坐标',worldPosition);
                // console.log('本地坐标',intersects[0].object.position);
                console.log("射线器返回对象", intersects);
              }else{
                console.log('null');
              }
            })
          },
          stopclip(number){ //停在模型动画时间轴上的任意时间
            let _this = this
            const mixer = new THREE.AnimationMixer(_this.model);
            //  获取gltf.animations[0]的第一个clip动画对象
            _this.clipAction = mixer.clipAction(_this.init_model.animations[0]); //创建动画clipAction对象
            // 设置动画播放的起始时间和结束时间
            _this.clipAction.paused = true;//暂停状态拖动拖动条
            _this.clipAction.time = number //物体状态为动画第number秒对应状态
            // }, item.animationend);
            _this.clipAction.play(); //播放动画
            //不循环播放
            _this.clipAction.loop = THREE.LoopOnce;
            // 物体状态停留在动画结束的时候
            _this.clipAction.clampWhenFinished = true;
            // 如果想播放动画,需要周期性执行`mixer.update()`更新AnimationMixer时间数据
            const clock = new THREE.Clock();
            function loop() {
              requestAnimationFrame(loop);
              //clock.getDelta()方法获得loop()两次执行时间间隔
              const frameT = clock.getDelta();
              // 更新播放器相关的时间
              mixer.update(frameT);
            }
            loop();

          },
          callAnimation(item){ //解析外部模型关键帧动画
            let _this =this
            if(_this.clipAction){ //如果有动画则先停止播放
              _this.clipAction.stop()
            }
            const mixer = new THREE.AnimationMixer(_this.model);
            //  获取gltf.animations[0]的第一个clip动画对象
            _this.clipAction = mixer.clipAction(_this.init_model.animations[item.animationnumber]); //创建动画clipAction对象
            // 设置动画播放的起始时间和结束时间
            _this.clipAction.time = item.animationstart
            // 设置动画播放的结束时间
            if(_this.animationtimeout){
              clearTimeout(_this.animationtimeout)
            }
            _this.animationtimeout = setTimeout(() => {
              _this.clipAction.paused = true;//暂停状态拖动拖动条
            }, item.animationend);
            _this.clipAction.play(); //播放动画

            this.displayAllPart()
            this.cancellationallsettimeout()
            for (let i = 0; i < item.hideComponent.length; i++) {
              if(item.hideComponent[i] == "yidonglist"){
                for (let j = 0; j <= 19; j++) {
                  if( j == 1 ){
                    continue;
                  }
                  let str = j+'yidong'
                  _this.hideMorphingAnimation(str)
                }
              }else{
                this.hideMorphingAnimation(item.hideComponent[i])
              }
            }
            if(item.animationnumber){ //装配动画(1)
              _this.assShadowHiddenParts(item)
            }else{ //-------------------拆卸动画(0)
              _this.disShadowHiddenParts(item)
            }
            //不循环播放
            _this.clipAction.loop = THREE.LoopOnce;
            // 物体状态停留在动画结束的时候
            _this.clipAction.clampWhenFinished = true;
            // 如果想播放动画,需要周期性执行`mixer.update()`更新AnimationMixer时间数据
            const clock = new THREE.Clock();
            function loop() {
              requestAnimationFrame(loop);
              //clock.getDelta()方法获得loop()两次执行时间间隔
              const frameT = clock.getDelta();
              // 更新播放器相关的时间
              mixer.update(frameT);
            }
            loop();
          },
          displayAllPart(){ //显示所有零件
            let _this = this
            for (let i = 0; i < this.allcomponent.length; i++) {
              if(this.allcomponent[i] == 'yidonglist'){
                for (let j = 0; j <= 19; j++) {
                  if( j == 1 ){
                    continue;
                  }
                  let str = j+'yidong'
                  _this.displayMorphingAnimation(str)
                }
              }else{
                  _this.displayMorphingAnimation(this.allcomponent[i])
              }
            }
          },
          cancellationallsettimeout(){ //取消所有显示隐藏逻辑计时器
            for (let i = 0; i < this.animationtimeoutlist.length; i++) {
              clearTimeout(this.animationtimeoutlist[i])
            }
            this.animationtimeoutlist = []
          },
          hideMorphingAnimation(name){ //隐藏的过渡动画
            // let _this = this
            this.model.getObjectByName(name).visible = false
            // _this.model.getObjectByName(name).traverse(function (object) {
            //   if (object.type === 'Mesh') {
            //     new TWEEN.Tween({opacity:object.material.opacity})//创建一段tween动画
            //     .to({opacity:0.0}, 0)
            //     .onStart(function(){
            //       //动画开始：允许透明opacity属性才能生效
            //       object.material.transparent = true;//开启透明计算
            //     })
            //     .onUpdate(function(obj){
            //       object.material.opacity = obj.opacity
            //       // console.log(obj.opacity);
            //     })
            //     .start();
            //   }
            // })
          },
          displayMorphingAnimation(name){ //显示的过渡动画
            this.model.getObjectByName(name).visible = true
          },
          disShadowHiddenParts(item){ //拆卸动画隐藏零件逻辑
            let _this = this
            console.log('拆卸',item.animationnum);
            switch (item.animationnum) {
              case 1:  //------------------------------------------------
                _this.animationtimeoutlist.push(
                  setTimeout(() => {
                    _this.displayMorphingAnimation("1sgd")
                    _this.displayMorphingAnimation("7yidong")
                    _this.displayMorphingAnimation("8yidong")
                    _this.displayMorphingAnimation("2sgd")
                  }, 8000),
                  setTimeout(() => {
                    _this.displayMorphingAnimation("1dwx")
                    _this.displayMorphingAnimation("2dwx")
                    _this.displayMorphingAnimation("16yidong")
                    _this.displayMorphingAnimation("17yidong")
                  }, 9000)
                )
                break;
              case 2:  //------------------------------------------------
                _this.animationtimeoutlist.push(
                  setTimeout(() => {
                    this.hideMorphingAnimation("jiantou2")
                  }, 2000),
                  setTimeout(() => {
                    this.hideMorphingAnimation("1ls")
                  }, 3000),
                  setTimeout(() => {
                    this.hideMorphingAnimation("1b")
                    this.hideMorphingAnimation("2b")
                    for (let j = 0; j <= 19; j++) {
                      if( j == 1 ){
                        continue;
                      }
                      let str = j+'yidong'
                      _this.hideMorphingAnimation(str)
                    }
                  }, 5000)
                )
                break;
              case 3:  //------------------------------------------------
                _this.animationtimeoutlist.push(
                  setTimeout(() => {
                    // this.displayMorphingAnimation("jiantou1")
                    // this.displayMorphingAnimation("jiantou3")
                  }, 0),
                  setTimeout(() => {
                    this.displayMorphingAnimation("7dwx")
                    this.displayMorphingAnimation("8dwx")
                  }, 1000),
                  setTimeout(() => {
                    this.hideMorphingAnimation("1dwx")
                    this.hideMorphingAnimation("2dwx")
                    this.displayMorphingAnimation("jiantou1")
                  }, 4000),
                  setTimeout(() => {
                    this.hideMorphingAnimation("jiantou1")
                    this.displayMorphingAnimation("jiantou3")
                  }, 9000),
                  setTimeout(() => {
                    this.displayMorphingAnimation("jiantou1")
                    this.hideMorphingAnimation("jiantou3")
                  }, 11000),
                  setTimeout(() => {
                    this.hideMorphingAnimation("jiantou1")
                  }, 13000),
                  setTimeout(() => {
                    this.displayMorphingAnimation("5dwx")
                    this.displayMorphingAnimation("6dwx")
                  }, 14000)
                )
                break;
              case 4:  //------------------------------------------------
                _this.animationtimeoutlist.push(
                  setTimeout(() => {
                    this.displayMorphingAnimation("jiantou1")
                  }, 2000),
                  setTimeout(() => {
                    this.hideMorphingAnimation("jiantou1")
                  }, 5000),
                  setTimeout(() => {
                    this.displayMorphingAnimation("1dwx")
                    this.displayMorphingAnimation("2dwx")
                    this.displayMorphingAnimation("3dwx")
                    this.displayMorphingAnimation("4dwx")
                  }, 7000),
                  setTimeout(() => {
                    this.displayMorphingAnimation("2ls")
                  }, 8000),
                  setTimeout(() => {
                    this.displayMorphingAnimation("jiantou3")
                  }, 8500),
                  setTimeout(() => {
                    this.hideMorphingAnimation("2ls")
                  }, 9000),
                  setTimeout(() => {
                    this.hideMorphingAnimation("jiantou3")
                  }, 10500)
                )
                break;
              case 5:  //------------------------------------------------
                _this.displayMorphingAnimation("banshou")
                _this.animationtimeoutlist.push(
                  setTimeout(() => {
                    _this.hideMorphingAnimation("banshou")
                  }, 11000)
                )
                break;
              default:
                break;
            }
          },
          assShadowHiddenParts(item){ //装配动画隐藏零件逻辑
            let _this = this
            console.log('装配',item.animationnum);
            switch (item.animationnum) {
              case 1:  //------------------------------------------------
                _this.animationtimeoutlist.push(
                  setTimeout(() => {
                    _this.displayMorphingAnimation("banshou")
                  }, 0),
                  setTimeout(() => {
                    _this.hideMorphingAnimation("banshou")
                  }, 10000)
                )
                break;
              case 2:  //------------------------------------------------
                _this.animationtimeoutlist.push(
                  setTimeout(() => {
                    this.displayMorphingAnimation("2ls")
                  }, 0),
                  setTimeout(() => {
                    this.hideMorphingAnimation("jiantou3")
                  }, 2000),
                  setTimeout(() => {
                    this.hideMorphingAnimation("3dwx")
                    this.hideMorphingAnimation("4dwx")
                  }, 4000),
                  setTimeout(() => {
                    this.displayMorphingAnimation("jiantou1")
                  }, 4000),
                  setTimeout(() => {
                    this.hideMorphingAnimation("jiantou1")
                  }, 7000),
                )
                break;
              case 3:  //------------------------------------------------
                _this.animationtimeoutlist.push(
                  setTimeout(() => {
                    this.hideMorphingAnimation("1dwx")
                    this.hideMorphingAnimation("2dwx")
                  }, 1000),
                  setTimeout(() => {
                    this.hideMorphingAnimation("4dwx")
                    this.hideMorphingAnimation("5dwx")
                    this.hideMorphingAnimation("6dwx")
                  }, 1500),
                  setTimeout(() => {
                    this.displayMorphingAnimation("jiantou1")
                  }, 2000),
                  setTimeout(() => {
                    this.hideMorphingAnimation("jiantou1")
                    this.displayMorphingAnimation("jiantou3")
                  }, 4000),
                  setTimeout(() => {
                    this.displayMorphingAnimation("jiantou1")
                    this.hideMorphingAnimation("jiantou3")
                  }, 6000),
                  setTimeout(() => {
                    this.displayMorphingAnimation("1dwx")
                    this.displayMorphingAnimation("2dwx")
                    this.hideMorphingAnimation("jiantou1")
                  }, 11000),
                )
                break;
              case 4:  //------------------------------------------------
                _this.animationtimeoutlist.push(
                  setTimeout(() => {
                    for (let j = 0; j <= 19; j++) {
                      if( j == 1 ){
                        continue;
                      }
                      let str = j+'yidong'
                      _this.displayMorphingAnimation(str)
                    }
                  }, 2000),
                  setTimeout(() => {
                    this.displayMorphingAnimation("1ls")
                  }, 6000),
                  setTimeout(() => {
                    this.hideMorphingAnimation("jiantou2")
                  }, 6500),
                )
                break;
              case 5:  //------------------------------------------------
                _this.animationtimeoutlist.push(
                  setTimeout(() => {
                    this.hideMorphingAnimation("1dwx")
                    this.hideMorphingAnimation("2dwx")
                    this.hideMorphingAnimation("7dwx")
                    this.hideMorphingAnimation("8dwx")
                    this.hideMorphingAnimation("1sgd")
                    this.hideMorphingAnimation("2sgd")
                    this.hideMorphingAnimation("7yidong")
                    this.hideMorphingAnimation("8yidong")

                    this.hideMorphingAnimation("16yidong")
                    this.hideMorphingAnimation("17yidong")
                  }, 3000)
                )
                break;
              default:
                break;
            }
          },
          /**
           * @description 测试按钮
           */
          test(){
            // 创建精灵材质对象SpriteMaterial
            // const spriteMaterial = new THREE.SpriteMaterial({
            //   color:0x00ffff,//设置颜色
            // });
            // // 创建精灵模型对象，不需要几何体geometry参数
            // const sprite = new THREE.Sprite(spriteMaterial);
            // this.model.add(sprite);
            console.log(this.camera.position.x,this.camera.position.y,this.camera.position.z);
          },
        }
    }
</script>

<style scoped>
  .v-enter{
    opacity: 0;
  }

  .v-enter-to{
    opacity: 1;
  }

  .v-enter-active{
    transition: all 1s;
  }
  .v-leave{
    opacity: 1;
  }
  .v-leave-to{
    opacity: 0;
  }
  .v-leave-active{
    transition: all 1s;
  }

  .test{
    position: absolute;
    z-index: 10000;
    top: 0px;
    background-color: red;
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    cursor: pointer;
  }
  @media (max-width:996px) {
    .app-text{
      top: 12vh;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/cmxcmodel.vue